// 定数定義集

export const USER_STORAGE_KEY = {
  企業ユーザー: 'U_企業ユーザー',
  事業所: 'U_事業所',
  計画書: 'U_計画書',
};

export const MONTHS_OF_YEAR = 12;

export const DAYS_OF_YEAR = 365;

export const 補助科目設定不可大分類s = ['株主資本', '評価･換算差額等', '新株予約権'];

export const DAYJS_Y_NUMBER_FORMAT = 'YYYY';

export const DAYJS_YM_NUMBER_FORMAT = 'YYYYMM';

export const 大分類_販売管理費 = '販売管理費';
